module.exports = __webpack_public_path__ + "media/images/writer/community/welcome-e128d8a24b4c35a3d9d4c0e554336188.png";